<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="670px" transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-icon
                        small
                        class="mr-2"
                        v-on="{ ...tooltip, ...on }"
                    >mdi-pencil</v-icon>
                </template>
                <span>Modificar</span>
            </v-tooltip>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle titulo="Modificar Historial" @cancelar="cancelar"/>
            </v-card-title>  
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Instalaci&oacute;n
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.instalacion"
                                disabled
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Año
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.anio"
                                disabled
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Nota
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.nota"
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrellas Blancas
                            </div>
                            <v-text-field 
                                v-model="estrellaMod.cantidadEstrellasBlancas"
                                required>
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Verde
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaVerdeBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Plateada
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaPlateadaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Estrella Anaranjada
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.estrellaAnaranjadaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-row align-center">
                            <div class="d-flex mr-3">
                                Inscrita sin informe
                            </div>
                            <v-checkbox
                                v-model="estrellaMod.inscritaBol"
                                color="#0B3F67">                    
                            </v-checkbox>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="loading" color="error" @click="cancelar">Cancelar</v-btn>
                <v-btn text :loading="loading" color="#0B3F67" @click="modificarEstrella">Modificar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "@/axios"
import ModalTitle from '@/components/utils/ModalTitleComponent'

export default {
    created() {
        axios.defaults.headers.common["Authorization"] = "Bearer " + this.$store.getters.token;
    },
    components: {
      ModalTitle
    },
    mounted() {
        this.estrellaMod = this.estrella
    },
    props: [
        'estrella',
        'id',
    ],
    data: () => ({
        dialog: false,
        loading: false,
        estrellaMod: {
            id: 0,
            nota: '',
            cantidadEstrellasBlancas: '',
            estrellaVerde: '',
            estrellaAnaranjada: '',
            estrellaPlateada: '',
            inscrita: '',
            instalacion: '',
            anio: '',
            estrellaVerdeBol: false,
            estrellaAnaranjadaBol: false,
            estrellaPlateadaBol: false,
            inscritaBol: false,
        }
    }),
    methods: {
        cancelar() {
            this.dialog = false;
            this.loading = false;
        },
        modificarEstrella() {
            this.loading = true;
            axios.post("/instalaciones/modificarHistorialEstrella", this.estrellaMod).then(() => {
                this.$emit("recargaTabla");
                this.$store.dispatch("noti", { mensaje: "Historial modificado", color: "success" });
                this.cancelar();
            }).catch(error => {
                if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
                } else {
                console.log("Error al modificar programa " + error);
                this.$store.dispatch("noti", { 
                    mensaje: "Ocurrió un error no se modificó el programa",
                    color: "error"
                });
                this.cancelar();
                }
            });
        }
    }
};
</script>
